<template>
  <table class="TB_COLLAPSE default" width="100%">
    <thead>
      <th colspan="8">基本讯息</th>
    </thead>
    <tbody>
      <tr>
        <th width="12.5%">站点名称</th>
        <td width="12.5%">
          <Input v-model="form.memname" style="width: 180px" />
        </td>
        <th width="12.5%">站点帐号</th>
        <td width="12.5%">
          <p v-if="fixStatus">{{ form.uname }}</p>
          <Input v-else v-model="form.uname" style="width: 180px" />
        </td>
        <th width="12.5%">密码</th>
        <td width="12.5%">
          <Input v-model="form.upass" style="width: 180px" />
        </td>
        <th width="12.5%">确认密码</th>
        <td width="12.5%">
          <Input v-model="form.chpassword" style="width: 180px" />
        </td>
      </tr>
      <tr>
        <th>状态</th>
        <td>
          <RadioGroup v-model="form.state">
            <Radio :label="1">啟用</Radio>
            <Radio :label="0">停用</Radio>
          </RadioGroup>
        </td>
        <th>网站类别</th>
        <td>
          <RadioGroup v-model="form.oneorall">
            <Radio :label="1" :disabled="SiteClass">港六</Radio>
            <Radio :label="2" :disabled="SiteClass">整合</Radio>
          </RadioGroup>
        </td>
        <th>低頻彩连动赔率</th>
        <td>
          <RadioGroup v-model="form.islinkodds">
            <Radio :label="1">啟用</Radio>
            <Radio :label="0">停用</Radio>
          </RadioGroup>
        </td>
        <th>低頻彩连动开奖</th>
        <td>
          <RadioGroup v-model="form.unified_draw">
            <Radio :label="1">啟用</Radio>
            <Radio :label="0">停用</Radio>
          </RadioGroup>
        </td>
      </tr>
      <tr>
        <th>站别类型</th>
        <td>
          <Select v-model="form.siteClass" style="width: 150px">
            <Option
              v-for="item in siteSelect"
              :value="item.id"
              :key="item.id"
            >{{ item.value }}
            </Option>
          </Select>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import siteGroup from 'utils/site-group.js'
export default {
  props: {
    formProps: {
      type: [Object, Array],
      default: function () {
        return {}
      }
    },
    SiteClass: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      form: {
        uname: "",
        memname: "",
        upass: "",
        chpassword: "",
        state: 1,
        phone: "",
        email: "",
        oneorall: 1,
        islinkodds: 0,
        unified_draw: 0,
        siteClass: 0
      }
    };
  },
  computed: {
    fixStatus () {
      if (!this.formProps) return
      return Object.keys(this.formProps).length
    },
    CQ9State () {
      return process.env.VUE_APP_CQ9_STATE == 'true' && this.fixStatus
    },
    siteSelect () {
      return siteGroup.list()
    }
  },
  watch: {
    formProps (val) {
      if (!this.fixStatus) return
      this.$set(this.form, 'uname', val.username)
      this.$set(this.form, 'memname', val.memname)
      this.$set(this.form, 'state', val.state)
      this.$set(this.form, 'phone', val.phone)
      this.$set(this.form, 'email', val.email)
      this.$set(this.form, 'oneorall', val.oneorall)
      this.$set(this.form, 'islinkodds', val.islinkodds)
      this.$set(this.form, 'unified_draw', val.unified_draw)
      this.$set(this.form, 'siteClass', val.siteClass)
    }
  }
};
</script>